<template>
  <div class="add-contractor-container">
    <!-- Nagłówek -->
    <div class="page-header">
      <h2 class="page-title">➕ Dodaj kontrahenta</h2>
      <p class="page-subtitle">Wybierz typ kontrahenta, którego chcesz dodać</p>
    </div>

    <!-- Karty wyboru -->
    <div class="cards-container">
      <router-link to="/addcompany" class="contractor-card company-card">
        <div class="card-icon">🏢</div>
        <h3 class="card-title">Firma</h3>
        <p class="card-description">Dodaj kontrahenta firmowego z danymi NIP</p>
        <div class="card-arrow">→</div>
      </router-link>

      <router-link to="/addcustomer" class="contractor-card customer-card">
        <div class="card-icon">👤</div>
        <h3 class="card-title">Klient indywidualny</h3>
        <p class="card-description">Dodaj klienta prywatnego</p>
        <div class="card-arrow">→</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddContractor",
};
</script>

<style scoped>
/* --- Kontener główny --- */
.add-contractor-container {
  padding: 40px 20px;
  background: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* --- Nagłówek --- */
.page-header {
  text-align: center;
  margin-bottom: 50px;
}

.page-title {
  margin: 0;
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
}

.page-subtitle {
  margin: 0;
  font-size: 16px;
  color: #6c757d;
  font-weight: 400;
}

/* --- Kontener kart --- */
.cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  max-width: 1000px;
  width: 100%;
}

/* --- Karty kontrahentów --- */
.contractor-card {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  min-height: 280px;
  cursor: pointer;
}

.contractor-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.contractor-card:hover::before {
  transform: scaleX(1);
}

.contractor-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.3);
}

.company-card:hover {
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.3);
}

.customer-card:hover {
  box-shadow: 0 12px 40px rgba(17, 153, 142, 0.3);
}

/* --- Ikona karty --- */
.card-icon {
  font-size: 80px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.contractor-card:hover .card-icon {
  transform: scale(1.2);
}

/* --- Tytuł karty --- */
.card-title {
  margin: 0 0 15px 0;
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
}

.company-card:hover .card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.customer-card:hover .card-title {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* --- Opis karty --- */
.card-description {
  margin: 0 0 25px 0;
  font-size: 15px;
  color: #6c757d;
  line-height: 1.6;
}

/* --- Strzałka --- */
.card-arrow {
  margin-top: auto;
  font-size: 32px;
  font-weight: 700;
  color: #e9ecef;
  transition: all 0.3s ease;
}

.company-card:hover .card-arrow {
  color: #667eea;
  transform: translateX(10px);
}

.customer-card:hover .card-arrow {
  color: #11998e;
  transform: translateX(10px);
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .add-contractor-container {
    padding: 20px 15px;
  }

  .page-title {
    font-size: 28px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .cards-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .contractor-card {
    padding: 30px;
    min-height: 240px;
  }

  .card-icon {
    font-size: 60px;
  }

  .card-title {
    font-size: 24px;
  }

  .card-description {
    font-size: 14px;
  }
}
</style>
